import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-unpaid-granth-outstanding-brief',
  templateUrl: './unpaid-granth-outstanding-brief.component.html',
  styleUrl: './unpaid-granth-outstanding-brief.component.scss'
})
export class UnpaidGranthOutstandingBriefComponent {
  startDate: any = '';
  endDate: any = '';

  repName: any[] = [];
  offRepName: any[] = [];
  booksellerName: any[] = [];

  reportType = '';
  currentDate = new Date();

  // API Response - matches template's *ngFor="let data of UnpaidOutstandingB"
  UnpaidOutstandingB: any[] = [];

  // Grand Totals - match template bindings directly
  unpaidtotalInvAmount = 0;
  unpaidtotalPaidAmount = 0;
  unpaidtotalCrdtAmount = 0;
  unpaidtotalUnpaidAmount = 0;

  constructor(
    private dialogRef: MatDialogRef<UnpaidGranthOutstandingBriefComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private datePipe: DatePipe
  ) {}

  ngOnInit(): void {

    this.startDate = this.data?.startDate;
    this.endDate = this.data?.endDate;

    this.reportType = this.data?.reportType || '';

    this.repName = this.data?.repName || [];
    this.offRepName = this.data?.officeRepWise || [];
    this.booksellerName = this.data?.bookSellerWise || [];

    this.loadReport();
  }

  loadReport(): void {

    const req: any = {};

    if (this.startDate) {
      req.start_date = this.startDate;
    }

    if (this.endDate) {
      req.end_date = this.endDate;
    }

    if (this.repName.length) {
      req.rep_name = this.repName;
    }

    if (this.offRepName.length) {
      req.office_rep_name = this.offRepName;
    }

    if (this.booksellerName.length) {
      req.book_seller_name = this.booksellerName;
    }

    console.log('Request', req);

    this.service.getBookUnpaidOutstandingBreiflygranth(req).subscribe({

      next: (response: any) => {

        console.log('Outstanding Detail', response);

        this.UnpaidOutstandingB = response?.UnpaidOutstandingB || [];

        this.unpaidtotalInvAmount = Number(response?.unpaidtotalInvAmount) || 0;
        this.unpaidtotalPaidAmount = Number(response?.unpaidtotalPaidAmount) || 0;
        this.unpaidtotalCrdtAmount = Number(response?.unpaidtotalCrdtAmount) || 0;
        this.unpaidtotalUnpaidAmount = Number(response?.unpaidtotalUnpaidAmount) || 0;

        console.log('Invoice Total :', this.unpaidtotalInvAmount);
        console.log('Paid Total :', this.unpaidtotalPaidAmount);
        console.log('Credit Total :', this.unpaidtotalCrdtAmount);
        console.log('Unpaid Total :', this.unpaidtotalUnpaidAmount);

        this.cdr.detectChanges();

      },

      error: (err) => {
        console.error('Error loading report', err);
      }

    });

  }

  printPageA41(): void {

    const printContent = document.getElementById('print-section');

    if (!printContent) {
      return;
    }

    const win = window.open('', '', 'width=1200,height=800');

    if (!win) {
      return;
    }

    win.document.write(`
      <html>
      <head>

        <title>Book Outstanding Detail Report</title>

        <style>

          @page{
            size:A4 landscape;
            margin:8mm;
          }

          body{
            font-family:Arial, sans-serif;
            font-size:12px;
            margin:0;
            padding:0;
          }

          table{
            width:100%;
            border-collapse:collapse;
          }

          th,td{
            border:1px solid #000;
            padding:5px;
            text-align:center;
          }

          thead{
            display:table-header-group;
          }

          tr{
            page-break-inside:avoid;
          }

        </style>

      </head>

      <body>

      ${printContent.innerHTML}

      </body>

      </html>
    `);

    win.document.close();

    setTimeout(() => {
      win.print();
      win.close();
    }, 500);

  }

  exportExcel(fileName: string): void {

    console.log('Export Excel:', fileName);

    // Add XLSX export logic here.

  }

  close(): void {
    this.dialogRef.close();
  }

}